module.exports = __webpack_public_path__ + "static/media/status_red.fcdf9e48.svg";